import { render, staticRenderFns } from "./bug_list.vue?vue&type=template&id=87be3232&"
import script from "./bug_list.vue?vue&type=script&lang=js&"
export * from "./bug_list.vue?vue&type=script&lang=js&"
import style0 from "./bug_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports